import React, { useContext, useEffect, useState } from 'react'
import GameServices from '../../../services/game-service'
import useMediaQuery from '../../../utils/useMediaQuery'
import userSessionStorage from '../../../utils/userSessionStorage'
import Button from '../../atoms/button/button'
import './top-section.scss'
import {
  activity_dates,
  topNumber,
  gameId,
  LOCALE,
} from '../../../constants/activity-constants'
import { Context } from '../../../context/app-context'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import { jsonToHash } from '../../../utils/crypto'
import { navigate } from 'gatsby'
import { siteUrl } from '../../../shared/utils/siteUrl'
import { WORDS } from '../../../constants/keywords'

const TopSection = ({ id, className }) => {
  const isMobile = useMediaQuery()

  const session = new userSessionStorage()

  const { dispatch } = useContext(Context)

  const userInfo = session.getUserInfo()
  const [logged, setIsLogged] = useState(false)
  const [topWinners, setTopWinners] = useState([])
  const [userData, setUserData] = useState({})

  const handlerGoToRegister = () => {
    window.open(siteUrl + '/registro', '_BLANK')
  }

  const handlerGoToGame = () => {
    navigate('/game')
  }

  const toggleButton = async evt => {
    if (evt) {
      let text = evt.target?.innerText

      if (text) {
        pushEventData({
          event: 'Interacciones_Home_RompeTabus',
          label: text,
          user_data: userInfo && [
            await jsonToHash({
              nombre: userInfo.name,
              apellido: userInfo.lastName,
              celular: userInfo.cellPhone,
              correo: userInfo.email,
              ciudad: userInfo.location.cityName,
              departamento: userInfo.location.countryStateName,
              pais: userInfo.countryName,
            }),
          ],
          log_status: userInfo ? 'Yes' : 'Not',
        })
      }
    }
    handlerGoToGame()
  }

  const toggleLink = async evt => {
    if (evt) {
      let text = evt.target?.innerText

      if (text) {
        pushEventData({
          event: 'Interacciones_Enlaces',
          action: 'link',
          label: text,
          user_data: userInfo && [
            await jsonToHash({
              nombre: userInfo.name,
              apellido: userInfo.lastName,
              celular: userInfo.cellPhone,
              correo: userInfo.email,
              ciudad: userInfo.location.cityName,
              departamento: userInfo.location.countryStateName,
              pais: userInfo.countryName,
            }),
          ],
          log_status: userInfo ? 'Yes' : 'Not',
        })
      }
    }
    handlerGoToRegister()
  }

  useEffect(() => {
    getTop()
    setIsLogged(userInfo !== null)
  }, [])

  const handleDataLayer = async label => {
    pushEventData({
      event: 'Interacciones_Enlaces',
      action: 'link',
      label: label,
      user_data: userInfo && [
        await jsonToHash({
          nombre: userInfo.name,
          apellido: userInfo.lastName,
          celular: userInfo.cellPhone,
          correo: userInfo.email,
          ciudad: userInfo.location.cityName,
          departamento: userInfo.location.countryStateName,
          pais: userInfo.countryName,
        }),
      ],
      log_status: userInfo ? 'Yes' : 'Not',
    })
  }

  const handleLogin = () => {
    handleDataLayer('Inicia sesión')
    dispatch({
      type: 'set-modal',

      modalActive: {
        type: 'login',
        wrapperProps: { blur: true },
        props: {
          close: () => {
            dispatch({ type: 'clear-modal' })
            // navigate('/')
          },
          onEnd: () => {
            // window.location.reload()
            dispatch({ type: 'clear-modal' })
            dispatch({
              type: 'set-modal',
              modalActive: {
                type: 'updateData',
                wrapperProps: { blur: true },
                props: {
                  close: () => {
                    dispatch({ type: 'clear-modal' })
                    window.location.reload()
                  },
                  success: () => {
                    dispatch({ type: 'clear-modal' })
                    window.location.reload()
                  },
                },
              },
            })
            //navigate('/')
          },
          // mobile: isMobile,
        },
      },
    })
  }

  const getTop = () => {
    let tokenId = session.getToken()?.idToken
    const config = {
      headers: tokenId
        ? {
            Authorization: tokenId,
          }
        : undefined,
    }
    GameServices.getTopPagination(gameId, topNumber, 0, config).then(res => {
      if (res.status === 200) {
        setUserData(res.data)
        setTopWinners(res.data.topGame)
      }
    })
  }

  const formatNumber = number => {
    if (number) return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return 0
  }

  var viewLogged = () => (
    <>
      <br />
      <h2 className="--size26">¡Hola {userInfo.name.split(' ')[0]}!</h2>
      <br />
      <div className="f-top-section__info__container">
        <div className="f-top-section__info__container__points">
          <p>Tus puntos</p>
          <span> {userData.point ? formatNumber(userData.point) : 0} </span>
        </div>
        <div className="f-top-section__info__container__points">
          <p>Tu puesto</p>
          <span>{userData.position}</span>
        </div>
      </div>
      <p className="f-top-section__info__text --marginL13">
        Si no estás en nuestro top {topNumber}{' '}
        <span>
          ¡{WORDS.sigue} jugando y no te {WORDS.rindas}!{' '}
        </span>{' '}
        {WORDS.Tienes} hasta el {activity_dates[1]} para alcanzar los mejores puntajes.
        <br />
        <br />
        <span>{textParticipa()}</span>
      </p>
      <br />
    </>
  )
  const textNotlogged2 = () => {
    const $formas = LOCALE === 'es-PY' ? 'sos' : 'formas'
    return (
      <>
        Si aún no {$formas} parte de <br />
        NosotrasOnline regístrate{' '}
      </>
    )
  }
  const textParticipa = () => {
    if (LOCALE === 'es-PY') {
      return <>¡Participá y divertite!</>
    }
    return <>¡Participa y diviértete!</>
  }
  var viewNoLoggedMb = (
    <>
      <p className="f-top-section__info__text">
        <span>
          <a onClick={() => handleLogin()}>{WORDS.inicia_sesion}</a>
        </span>{' '}
        para conocer tu <br />
        puntaje y tu posición dentro del top <br />
        de jugadoras. <br />
        <br />
        {textNotlogged2()}
        <span>
          <a onClick={toggleLink}>{WORDS.aqui}</a>
        </span>
        <br />
        <br />
        <span>{textParticipa()}</span>
        <br />
        <br />
        Tienes hasta el {activity_dates[1]} para alcanzar <br /> los mejores
        puntajes.
      </p>
    </>
  )

  var viewNoLoggedDesk = (
    <>
      <p className="f-top-section__info__text">
        <span>
          <a onClick={() => handleLogin()}>{WORDS.inicia_sesion}</a>
        </span>{' '}
        para conocer tu puntaje y <br />
        tu posición dentro del top de jugadoras. <br />
        <br />
        {textNotlogged2()}
        <span>
          <a onClick={toggleLink}>{WORDS.aqui}</a>
        </span>
        <br />
        <br />
        <span>{textParticipa()}</span>
        <br />
        <br />
        Tienes hasta el {activity_dates[1]} para alcanzar <br /> los mejores
        puntajes.
      </p>
    </>
  )

  var viewNoLogged = isMobile ? viewNoLoggedMb : viewNoLoggedDesk
  const winnerList = [...topWinners]
  while (winnerList.length < 5) {
    winnerList.push(null)
  }
  const lastId = winnerList.length - 1

  return (
    <section id={id} className={'f-top-section ' + className}>
      <div className="f-top-section__wrapper">
        <div className="f-top-section__info">
          <h2>
            Top <br /> <span>Jugadoras</span>
          </h2>
          {logged ? viewLogged() : viewNoLogged}
        </div>
        <div className="f-top-section__right">
          <div className={'f-top-section__right__top'}>
            <div className="f-top-section__right__top__title">
              Las mejores jugadoras {isMobile && <br />} estan aquí:
            </div>
            {!isMobile && (
              <div className="f-top-section__right__top__headerList">
                <h3>Nombre</h3>
                <h3>Correo</h3>
              </div>
            )}
            <div
              className={
                'f-top-section__right__top__list ' +
                (lastId > 5 ? ' --overflowed' : '')
              }
            >
              {winnerList.map((user, idx) => {
                return (
                  <div
                    key={idx}
                    className={
                      'f-top-section__right__top__winners ' +
                      (idx === lastId ? '--radius' : '')
                    }
                  >
                    {user != null ? (
                      <>
                        <p className="--capitalize --ellipsis">
                          <span>{idx + 1}. </span>
                          {user.name}
                        </p>
                        {isMobile && <br />}
                        <p className="--ellipsis">{user.email}</p>
                      </>
                    ) : null}
                  </div>
                )
              })}
            </div>
          </div>
          <Button onClick={toggleButton} className="--top">
            Jugar
          </Button>
        </div>
      </div>
    </section>
  )
}

export default TopSection
